import React from "react";
import {useState} from "../state/useState";
import {order} from "../service/RechargeService";
import {redirectTo} from "../state/action";

export function ConfirmMobileData({operatorName, phoneNumber, amount}) {


    return <>
        <blockquote><p>Mobilna mreža: <strong>{operatorName}</strong></p></blockquote>
        <input type="hidden" name="op" ng-model="operaterData.operater.index"
               value="{{operaterData.operater.index}}"/>
        <blockquote><p>Broj telefona: <strong>{phoneNumber}</strong></p></blockquote>
        <input type="hidden" name="phN" ng-model="operaterData.phoneNumber"
               value="{{operaterData.phoneNumber}}"/>
        <blockquote><p>Iznos dopune: <strong>{amount} KM</strong></p></blockquote>
        <input type="hidden" name="amt" ng-model="operaterData.amount"
               value="{{operaterData.amount}}"/>
        <input type="hidden" name="com" value=""/>
    </>
}